import { createSelector } from '@reduxjs/toolkit';
import { emptyObject } from 'vet-bones/constants';

import { memoizeSelectorFactory } from 'src/selectors/memoizeSelectorFactory';
import { projectSelector } from 'src/selectors/project';
import { ProjectFileUpload } from 'src/store/state/projects';

export const projectFileUploadsByIdSelector = memoizeSelectorFactory(
  (projectId: string) =>
    createSelector(
      projectSelector(projectId),
      (project) =>
        project?.fileUploadsById ||
        (emptyObject as unknown as Record<string, ProjectFileUpload>)
    )
);
